import permissions from '@/config/permissions';

export default () => Object.keys(permissions).reduce((obj, key) => ({ ...obj, [key]: false }), {});
